import React, { useState, useEffect } from 'react';
import api from '../../services/api';

interface Props {
  onFilterChange: (filters: { category_id: string; region_id: string }) => void;
}

interface Category {
  id: number;
  name_ar: string;
  slug: string;
}

interface Region {
  id: number;
  name_ar: string;
}

const MapFilters: React.FC<Props> = ({ onFilterChange }) => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [regions, setRegions] = useState<Region[]>([]);
  const [categoryId, setCategoryId] = useState('');
  const [regionId, setRegionId] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [catRes, regRes] = await Promise.all([
          api.get('/categories'),
          api.get('/regions'),
        ]);
        setCategories(catRes.data.data || []);
        setRegions(regRes.data.data || []);
      } catch (err) {
        console.error('Error fetching filters:', err);
      }
    };
    fetchData();
  }, []);

  const handleCategoryChange = (val: string) => {
    setCategoryId(val);
    onFilterChange({ category_id: val, region_id: regionId });
  };

  const handleRegionChange = (val: string) => {
    setRegionId(val);
    onFilterChange({ category_id: categoryId, region_id: val });
  };

  const clearFilters = () => {
    setCategoryId('');
    setRegionId('');
    onFilterChange({ category_id: '', region_id: '' });
  };

  return (
    <div className="absolute top-4 right-4 z-[1000] bg-white rounded-xl shadow-lg p-3 flex gap-2 items-center flex-wrap max-w-md">
      <select
        value={categoryId}
        onChange={(e) => handleCategoryChange(e.target.value)}
        className="bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
      >
        <option value="">كل التصنيفات</option>
        {categories.map((cat) => (
          <option key={cat.id} value={cat.id}>{cat.name_ar}</option>
        ))}
      </select>

      <select
        value={regionId}
        onChange={(e) => handleRegionChange(e.target.value)}
        className="bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500"
      >
        <option value="">كل المناطق</option>
        {regions.map((reg) => (
          <option key={reg.id} value={reg.id}>{reg.name_ar}</option>
        ))}
      </select>

      {(categoryId || regionId) && (
        <button
          onClick={clearFilters}
          className="text-xs text-red-500 hover:text-red-700 px-2 py-1"
        >
          مسح الفلاتر
        </button>
      )}
    </div>
  );
};

export default MapFilters;
